import { Progress } from 'antd';
import { defaultColors } from '@/themes/antd-theme';

// ==============================|| Loader ||============================== //

const Loader = () => (
  <div
    className="fixed top-0 left-0 z-[2001] w-full"
    style={{
      margin: 0,
      padding: 0,
      lineHeight: 0
    }}
  >
    <Progress
      percent={100}
      showInfo={false}
      status="active"
      strokeColor={defaultColors.primary}
      style={{ margin: 0, padding: 0, lineHeight: 0 }}
    />
  </div>
);

export default Loader;
